import { PropsWithChildren } from 'react';
import { useInjection } from '@cp/shared/di';
import { EventBusContext, EventPublisherContext } from 'src/shared/eventBus';
import { EVENT_BUS_TOKEN } from './const';

export const EventBusProvider = (props: PropsWithChildren) => {
  const eventBus = useInjection(EVENT_BUS_TOKEN);
  return (
    <EventBusContext value={eventBus}>
      <EventPublisherContext value={eventBus}>{props.children}</EventPublisherContext>
    </EventBusContext>
  );
};
